import { render } from "./ViewUserPageView.vue?vue&type=template&id=633bb5ce"
import script from "./ViewUserPageView.vue?vue&type=script&lang=js"
export * from "./ViewUserPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__